import { Faq } from "@/common/types/inquiry";
import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { Loading } from "@/components/atoms/Loading";
import { TabList } from "@/components/molecules/TabList";
import { useQuery } from "@tanstack/react-query";
import { TabContent } from "@/components/organisms/TabContent";
import { FaqPartList } from "@/components/molecules/FaqPartList";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { faqPartCategory } from "@/data/category";
import { GET_FAQS_BY_CATEGORY } from "@/common/querykeys";
import { useNavigate, useParams } from "react-router";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";

/** 📡 API Layer */
const fetchFaqsByCategory = async (category: string): Promise<Faq[]> => {
  return await request<Faq[]>({
    method: "GET",
    url: `/inquiry/category/${category}`,
  });
};

export const InquiryFaqPage = () => {
  /** 🛣️ Navigation Capability Acquisition */
  const navigate = useNavigate();

  /** 📍 URL Parameter Access */
  const { faqCategory: categoryParam } = useParams<{
    faqCategory: string;
  }>();

  /** 🧺 Variables Defines */
  const category = categoryParam || faqPartCategory[0]?.id;

  /** 📡 API Layer */
  const { data: faqs, isPending } = useQuery({
    queryKey: [GET_FAQS_BY_CATEGORY, category],
    queryFn: () => fetchFaqsByCategory(category),
    initialData: [],
  });

  /** 🗺️ Navigation Handlers */
  const handleTabChange = (tabId: string) => {
    navigate(`/setting/inquiry/faq/${tabId}`);
  };

  return (
    <>
      {isPending ? (
        <Loading />
      ) : (
        <MainTemplate
          nav={false}
          subPage={false}
          menuBtn={false}
          pageTitle="자주 묻는 질문"
          buttonLeft={
            <Buttons
              type="button"
              size="headerTextIcon"
              layout="text"
              color="bright100"
              icon={<IconArrow />}
              label="뒤로"
              onClick={() => navigate("/setting/inquiry")}
            />
          }
        >
          <TabContent
            nav={false}
            tabList={
              <TabList
                data={faqPartCategory}
                activeTab={category}
                onTabChange={handleTabChange}
              />
            }
          >
            <FaqPartList faqs={faqs} isLoading={isPending} />
          </TabContent>
        </MainTemplate>
      )}
    </>
  );
};
